import { render, staticRenderFns } from "./SongsEn.vue?vue&type=template&id=74da935e&"
import script from "./SongsEn.vue?vue&type=script&lang=js&"
export * from "./SongsEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports